export default __webpack_public_path__ + "static/media/rings2.a447a3ca.webp";